import { ReactNode } from 'react';
import './BordAcordeon.scss';

const BordAcordeon = ({
  children,
  isExpanded,
  customClassName = ''
}: IBordAcordeon) => {
  return (
    <div className={`bordAcordeon ${customClassName}`}>
      <div className={`bordAcordeonContent ${isExpanded ? 'bordAcordeonContentExpanded' : 'bordAcordeonContentCollapsed'}`}>
        {children}
      </div>
    </div>
  );
};

interface IBordAcordeon {
  children: ReactNode;
  isExpanded: boolean;
  customClassName?: string;
}

export default BordAcordeon;
